import React, { useEffect, useCallback } from 'react';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { useSelector } from 'react-redux';

import { keyEnterSubmitForm } from '../../../utilities/FormUtils';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import Button from '../../../control/button/Button';
import DatePicker from '../../../control/fdatetime/DateflatPicker';
import AutoComplete from '../../../control/autocomplete/AutoComplete';
import TextFields from '../../../control/textfield/TextFields';

const useStyles = makeStyles((theme) => ({
    spacing: {
        ...theme.form.spacing,
    },
    btnSearch: {
        width: '105px',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    btnReset: {
        backgroundColor: `${theme.mainTheme.color6} !important`,
        width: '105px',
        marginRight: '8px',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            marginRight: '0px',
            marginBottom: '2%',
        },
    },
}));

const formId = 'TimeClockPastWorkHistorySearchForm';

const SearchForm = ({
    initialize,
    reset,
    change,
    defaultValues,
    lookups,
    showOrganization,
    onSubmit,
}) => {
    const classes = useStyles();
    const values = useSelector((state) => getFormValues(formId)(state));

    useEffect(() => {
        initialize({ ...defaultValues });
    }, []);

    const handleChangeDate = useCallback(
        (field) => (value) => {
            if (value) {
                switch (field) {
                    case 'startDate':
                        if (values.endDate && value > values.endDate) {
                            change('endDate', value);
                        }
                        break;
                    case 'endDate':
                        if (values.startDate && value < values.startDate) {
                            change('startDate', value);
                        }
                        break;
                    default:
                        break;
                }
            }
        },
        [values, change],
    );

    const handleClickReset = useCallback(() => {
        reset(formId);
    }, [reset]);

    const handleClickSearch = useCallback(() => {
        const _values = { ...values };
        if (!showOrganization) {
            delete _values.orgId;
        }
        onSubmit(_values);
    }, [showOrganization, onSubmit, values]);

    return (
        <Grid container spacing={1}>
            {showOrganization && (
                <Grid item xs={12} md={6} lg={4} className={classes.spacing}>
                    <Field
                        name="orgId"
                        label="หน่วยงาน"
                        component={AutoComplete}
                        optionKey={{
                            label: 'name',
                            value: 'orgId',
                            abbr: 'nameSht',
                        }}
                        options={lookups.organization}
                    />
                </Grid>
            )}
            <Grid item xs={12} md={6} lg={4} className={classes.spacing}>
                <Field
                    name="keyword"
                    label="รหัสพนักงานหรือชื่อ-นามสกุล"
                    component={TextFields}
                    placeholder="รหัสพนักงานหรือชื่อ-นามสกุลผู้ยื่นคำขอเพิ่มบันทึกเวลา"
                    onKeyDown={keyEnterSubmitForm(handleClickSearch)}
                    maxLength={100}
                />
            </Grid>
            <Grid item xs={12} md={3} lg={2} className={classes.spacing}>
                <Field
                    id="start-date-search-absence"
                    name="startDate"
                    label="วันที่เริ่มต้น"
                    component={DatePicker}
                    onChange={handleChangeDate('startDate')}
                />
            </Grid>
            <Grid item xs={12} md={3} lg={2} className={classes.spacing}>
                <Field
                    id="end-date-search-absence"
                    name="endDate"
                    label="วันที่สิ้นสุด"
                    component={DatePicker}
                    onChange={handleChangeDate('endDate')}
                />
            </Grid>
            <Grid item xs={12} md={6} lg={4} className={classes.spacing}>
                <Field
                    name="pastWorkFormStateId"
                    label="สถานะ"
                    component={AutoComplete}
                    optionKey={{
                        value: 'id',
                        label: 'label',
                    }}
                    options={lookups.status}
                />
            </Grid>
            <Grid
                item
                xs={12}
                lg={8}
                container
                justify="flex-end"
                alignItems="center"
            >
                <Button
                    className={classes.btnReset}
                    onClick={handleClickReset}
                    label="ค่าเริ่มต้น"
                />
                <Button
                    className={classes.btnSearch}
                    onClick={handleClickSearch}
                    label="ค้นหา"
                />
            </Grid>
        </Grid>
    );
};

export default reduxForm({
    form: formId,
})(SearchForm);
